import { html } from 'lit-element'
import { until } from 'lit-html/directives/until.js'
import { ifDefined } from 'lit-html/directives/if-defined'
import { proxiedImageUrl, IMAGE_REGEX, CLICKABLE_REGION_REGEX } from '@polleverywhere/core/lib/util'

export function responseDetail (response) {
  const options = response.options
  const cipClick = CLICKABLE_REGION_REGEX.exec(response.value || '')

  if (response.rankings) {
    return html`
      <ol>
        ${response.rankings.map((option) => {
          if (IMAGE_REGEX.test(option.value)) {
            return html`<li><img src="${proxiedImageUrl(option.value, { w: 300, h: 150 })}"></li>`
          } else {
            return html`<li><span>${option.value}</span></li>`
          }
        })}
      </ol>
    `
  } else if (cipClick) {
    const content = new Promise((resolve) => {
      const image = new Image()
      image.onload = () => {
        resolve(html`<div class="response-history__detail__cip__image" style="padding-top:${(image.height / image.width) * 100}%">
          <img class="response-history__detail__cip__image__inner"  src=${image.src} />
          <icon-element style="top:${cipClick[2]}%;left:${cipClick[1]}%;" type="legacy-glyph" name="pin"></icon-element>
        </div>`)
      }
      image.src = proxiedImageUrl(response.poll.type_options?.imageUrl || '', { w: screen.width || 2000, h: screen.height || 2000, fit: 'max' })
    })
    return html`<div class="response-history__detail__cip" aria-label="${response.humanized_value}">
        ${until(content, html`<div class=element-skeleton-progress>&nbsp;</div>`)}
      </div>`
  } else if (options && options.length) {
    const activityGraded = !!response.poll.grading_enabled
    return html`
      <ul>
        ${options.map((option) => {
          const showCorrect = activityGraded && typeof option.correct !== 'undefined'
          const icon = showCorrect ? (option.correct ? 'checkmark' : 'close') : 'arrow-right'
          const correctText = showCorrect ? ', ' + (option.correct ? 'Correct' : 'Incorrect') : ''
          const ariaLabel = `${option.selected ? 'Selected' : 'Unselected'}${correctText}, response option: ${option.value}`
          const value = IMAGE_REGEX.test(option.value)
            ? html`<img src="${proxiedImageUrl(option.value, { w: 300, h: 150 })}" />`
            : html`<span>${option.value}</span>`
          return html`<li aria-label=${ariaLabel} data-selected=${option.selected} data-correct=${ifDefined(showCorrect ? option.correct : undefined)}>
            <icon-element type=glyph name=${icon}></icon-element>
            ${value}
          </li>`
        })}
      </ul>
    `
  }

  // Default
  return response.humanized_value
}
